/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

export enum UpdateActionDTOType {
  deliver= 'deliver',
  repair= 'repair',
  carry= 'carry',
  change_oil= 'change_oil',
  clean_filtration_system= 'clean_filtration_system',
  cleaning= 'cleaning',
  cleaning_of_the_turbocharger= 'cleaning_of_the_turbocharger',
  service= 'service',

}